/**
 * 此文件用于定义自定义块主题
 */
const Blockly = window.Blockly;
var defaultBlockStyles = {
  colour_blocks: {
    colourPrimary: "%{BKY_NUWA_CATEGORY_LIGHT_COLOR}"
  },
  list_blocks: {
    colourPrimary: "%{BKY_NUWA_CATEGORY_LIST_COLOR}"
  },
  logic_blocks: {
    colourPrimary: "%{BKY_NUWA_CATEGORY_LOGIC_COLOR}"
  },
  loop_blocks: {
    colourPrimary: "%{BKY_NUWA_CATEGORY_LOOP_COLOR}"
  },
  math_blocks: {
    colourPrimary: "%{BKY_NUWA_CATEGORY_MATH_COLOR}"
  },
  procedure_blocks: {
    colourPrimary: "%{BKY_NUWA_CATEGORY_FFUNCTION_COLOR}"
  },
  text_blocks: {
    colourPrimary: "%{BKY_NUWA_CATEGORY_TEXT_COLOR}"
  },
  variable_blocks: {
    colourPrimary: "%{BKY_NUWA_CATEGORY_VARIABLE_COLOR}"
  },
  variable_dynamic_blocks: {
    colourPrimary: "%{BKY_NUWA_CATEGORY_VARIABLE_COLOR}"
  },
  hat_blocks: {
    colourPrimary: "#ffffff",
    hat: "cap"
  }
};
var categoryStyles={
  colour_category:{colour:"%{BKY_NUWA_CATEGORY_LIGHT_COLOR}"},
  list_category:{colour:"%{BKY_NUWA_CATEGORY_LIST_COLOR}"},
  logic_category:{colour:"%{BKY_NUWA_CATEGORY_LOGIC_COLOR}"},
  loop_category:{colour:"%{BKY_NUWA_CATEGORY_LOOP_COLOR}"},
  math_category:{colour:"%{BKY_NUWA_CATEGORY_MATH_COLOR}"},
  procedure_category:{colour:"%{BKY_NUWA_CATEGORY_FFUNCTION_COLOR}"},
  text_category:{colour:"%{BKY_NUWA_CATEGORY_TEXT_COLOR}"},
  variable_category:{colour:"%{BKY_NUWA_CATEGORY_VARIABLE_COLOR}"},
  variable_dynamic_category:{colour:"%{BKY_NUWA_CATEGORY_VARIABLE_COLOR}"}
};
Blockly.Themes.Nuwa=new Blockly.Theme(defaultBlockStyles, categoryStyles);